import { TRX_TYPE } from "./transaction";

export const TEMPORARY_HIDDEN_COUNTRY = {
  [TRX_TYPE.BUSINESS]: [],
  [TRX_TYPE.PERSONAL]: ["CHN"]
};

export const COUNTRY_ISO_CODE = {
  PHILIPPINES: "PHL",
  CHINA: "CHN"
};

export const CC_NUMBER_CHINA_B2B = [
  622148, 622149, 622156, 622157, 622206, 622210, 622211, 622212, 622213, 622214, 622215, 622220, 622223, 622224,
  622225, 622229, 622230, 622231, 622232, 622233, 622234, 622235, 622237, 622238, 622239, 622240, 622245, 622246,
  622250, 622251, 622268, 622269, 622283, 62228306, 62228308, 622284, 622285, 622288, 622300, 622416, 622525, 622526,
  622570, 622648, 622650, 622655, 622657, 622658, 622659, 622680, 622685, 622686, 622687, 622688, 622689, 622707,
  622752, 622753, 622754, 622755, 622756, 622757, 622758, 622759, 622760, 622761, 622762, 622763, 622764, 622765,
  622766, 622767, 622768, 622788, 622906, 62451804, 62451810, 62451811, 6245806, 62458071, 625099, 625121, 625150,
  625192, 62519302, 62519318, 62519353, 62519365, 62519390, 625195, 625200, 625203, 625205, 625206, 625247, 625248,
  625249, 625250, 6253098, 625339, 625357, 625359, 625360, 625361, 625519, 62560600, 62565800, 625818, 625834, 625839,
  625889, 62589701, 62589702, 62589710, 62589711, 625902, 625902001, 625908, 625909, 625953, 625955, 625956, 625975,
  625976, 625979, 625981, 625993, 628201, 628202, 628206, 628208, 628209, 628210, 628230, 628244, 628248, 628254,
  628264, 628276, 628280, 628286, 628288, 628289, 628291, 628309, 628320, 628326, 628337, 628342, 628364, 628379,
  628386, 628388, 628399, 62565803
];
